import React, { useRef } from 'react';
import { useReduxSelector } from '../../../../redux/hooks';

const ActionExpander: React.FC = () => {
    const actionExpanded = useReduxSelector(state => state.ticketDetailsUI.actionExpanded);
    const hiddenLink = useRef<HTMLAnchorElement>(null);
    const hiddenLinkEmail = useRef<HTMLAnchorElement>(null);
    const hiddenLinkEvent = useRef<HTMLAnchorElement>(null);

    //Toggle the add action pane if the redux state changes
    const [showAction, setShowAction] = React.useState(0);
    React.useEffect(() => {
        //Action expanded
        if (showAction !== actionExpanded) {
            setShowAction(actionExpanded);
            if (showAction === 1 || actionExpanded === 1)
                hiddenLink.current.click();
            if (showAction === 2 || actionExpanded === 2)
                hiddenLinkEmail.current.click();
            if (showAction === 3 || actionExpanded === 3)
                hiddenLinkEvent.current.click();
        }

    }, [actionExpanded]);

    return (<>
        <a ref={hiddenLink} className="hidden" data-bs-toggle="collapse" href="#collapseAction">
        </a>
        <a ref={hiddenLinkEmail} className="hidden" data-bs-toggle="collapse" href="#collapseEmail">
        </a>
        <a ref={hiddenLinkEvent} className="hidden" data-bs-toggle="collapse" href="#collapseEvent">
        </a>
    </>
    );
};

export default ActionExpander;